import { observer } from 'mobx-react-lite'
import MessageCheckIcon from '@ui-components-3/icons/lib/light/MessageCheck'

type SupportTicketConfirmationProps = {
  ticketId: string
  onClose: () => void
}

const SupportTicketConfirmation = ({ ticketId, onClose }: SupportTicketConfirmationProps) => {
  return (
    <div className="flex flex-col items-center text-center px-9 pt-[106px] pb-7 text-primary">
      <MessageCheckIcon className="w-16 h-16" aria-hidden="true" />
      <h6 className="typography-body-2xl text-[32px] font-medium mt-6">Thank you!</h6>
      <p className="typography-body-xl">Message sent.</p>
      <p className="typography-body-xl mt-3">Ticket number: {ticketId}</p>
      <button type="button" onClick={onClose} className="btn-small btn-primary-outlined self-end mt-[82px]">
        Close
      </button>
    </div>
  )
}

export default observer(SupportTicketConfirmation)
